import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import clsx from "clsx";
import { useState } from "react";
import rank1 from "src/assets/images/reputationRank/Rank1.png";
import rank2 from "src/assets/images/reputationRank/Rank2.png";
import rank3 from "src/assets/images/reputationRank/Rank3.png";
import rank4 from "src/assets/images/reputationRank/Rank4.png";
import rank5 from "src/assets/images/reputationRank/Rank5.png";
import TitleTypography from "src/components/Typography/TitleTypography";
import PaperWrapper from "src/components/Wrapper/PaperWrapper";
import { THEME_MODE } from "src/config/constants";
import { useReputationSelector } from "src/context/reputationContext";
import { numberWithCommas } from "src/services/utils";
import LockHoverButton from "../LockHoverButton";

const useStyle = makeStyles((theme) => ({
  root: {
    position: "relative",
    padding: "20px",
    background: theme.palette.type === THEME_MODE.DARK ? "#233345" : "#DFE2E8",
    [theme.breakpoints.up("sm")]: {
      height: 260,
    },
  },
  gridImage: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "center",
    },
  },
  fogContent: {
    filter: "blur(4px)",
  },
}));

export default function YourCurrentReputation({ isEmpty, onBuyTRAVAClick }) {
  const cls = useStyle();

  const [isShowLock, setShowLock] = useState(true);
  const reputationUser = useReputationSelector((state) => state.reputationUser);
  const userRank = useReputationSelector((state) => {
    if (!state.reputationUser) return [];
    return state.reputationUser.userRank;
  });

  const reputation = useReputationSelector((state) => {
    if (!state.reputationUser) return [];
    let reputation = [
      {
        id: 1,
        rank: "Rank 1",
        title: `Hold less than ${numberWithCommas(state.reputationUser.ranges[0], 2)} tokens for ${
          state.reputationUser.timeDuration / 86400
        } days`,
        image: rank1,
      },
      {
        id: 2,
        rank: "Rank 2",
        title: `Hold less than ${numberWithCommas(state.reputationUser.ranges[1], 2)} tokens for  ${
          state.reputationUser.timeDuration / 86400
        }  days`,
        image: rank2,
      },
      {
        id: 3,
        rank: "Rank 3",
        title: `Hold less than ${numberWithCommas(state.reputationUser.ranges[2], 2)} tokens for  ${
          state.reputationUser.timeDuration / 86400
        }  days`,
        image: rank3,
      },
      {
        id: 4,
        rank: "Rank 4",
        title: `Hold less than ${numberWithCommas(state.reputationUser.ranges[3], 2)} tokens for  ${
          state.reputationUser.timeDuration / 86400
        }  days`,
        image: rank4,
      },
      {
        id: 5,
        rank: "Rank 5",
        title: `Hold more than ${numberWithCommas(state.reputationUser.ranges[3], 2)} tokens for  ${
          state.reputationUser.timeDuration / 86400
        }  days`,
        image: rank5,
      },
    ];
    return reputation;
  });

  function checkUrl(item) {
    if (item.id === userRank) {
      return true;
    }
  }

  const dataUser = reputation.filter(checkUrl)[0];
  const image = dataUser?.image;

  return (
    <PaperWrapper
      title="Your Current Reputation"
      onMouseEnter={() => setShowLock(false)}
      onMouseLeave={() => setShowLock(true)}
      paperProps={{ className: cls.root }}
    >
      <Box width="100%" height="100%" className={(clsx, { [cls.fogContent]: isEmpty })}>
        {reputationUser ? (
          <Box>
            <Grid container spacing={4}>
              <Grid item sm={3} xs={12} className={cls.gridImage}>
                <img width={120} src={image} />
              </Grid>
              <Grid item sm={9} xs={12}>
                <Box>
                  <Typography color="textSecondary" style={{ fontSize: "14px" }}>
                    This is our default rank system. Each bond program may have its own rank system
                  </Typography>
                </Box>
                <Box mt={2}>
                  {reputation.map((item, index) => (
                    <Typography key={index} color="textSecondary" style={{ marginTop: "6px", fontSize: "14px" }}>
                      {item.rank}: {item.title}
                    </Typography>
                  ))}
                </Box>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <TitleTypography textProps={{ variant: "h4" }} title="Please connect your wallet first!" />
          </Box>
        )}
      </Box>
      {isEmpty && <LockHoverButton isShowLock={isShowLock} onBuyTRAVAClick={onBuyTRAVAClick} />}
    </PaperWrapper>
  );
}
